// FeedbackForm.js
import React, { useState, useContext } from 'react';
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  TextField,
  MenuItem,
  Button,
  Snackbar,
  Alert,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { axiosInstance } from '../axiosInstance';
import { AuthContext } from '../context/AuthContext';

const categories = ['Bug Report', 'Feature Request', 'General Comment'];

const FeedbackForm = ({ open, onClose }) => {
  const { accessToken } = useContext(AuthContext);

  const [message, setMessage] = useState('');
  const [category, setCategory] = useState('General Comment');
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [alert, setAlert] = useState({ open: false, severity: 'success', message: '' });

  const handleSubmit = async () => {
    if (!message || !category) {
      setAlert({ open: true, severity: 'error', message: 'Please fill out all required fields.' });
      return;
    }
    try {
      setSubmitting(true);
      await axiosInstance.post(
        '/api/feedback',
        { message, category, email },
        accessToken
          ? { headers: { Authorization: `Bearer ${accessToken}` } }
          : undefined
      );
      setAlert({ open: true, severity: 'success', message: 'Thanks for your feedback!' });
      setMessage('');
      setEmail('');
      setCategory('General Comment');
      onClose();
    } catch (error) {
      console.error('Error submitting feedback:', error);
      setAlert({ open: true, severity: 'error', message: 'Failed to submit feedback.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Drawer anchor="bottom" open={open} onClose={onClose}>
        <Box sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h6">Help us serve you better</Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Divider sx={{ my: 2 }} />

          <TextField
            label="Pleas share your thoughts with us"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            multiline
            rows={4}
            fullWidth
            required
            margin="normal"
          />

          <TextField
            select
            label="Select a category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            fullWidth
            margin="normal"
          >
            {categories.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            label="Your Email (optional)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            fullWidth
            margin="normal"
          />

          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button onClick={onClose} color="secondary" sx={{ mr: 2 }}>
              Cancel
            </Button>
            <Button onClick={handleSubmit} color="primary" variant="contained" disabled={submitting}>
              Submit
            </Button>
          </Box>
        </Box>
      </Drawer>

      <Snackbar
        open={alert.open}
        autoHideDuration={3000}
        onClose={() => setAlert({ ...alert, open: false })}
      >
        <Alert severity={alert.severity} sx={{ width: '100%' }}>
          {alert.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default FeedbackForm;
